export default {
  createEvent: 'Utwórz wydarzenie',
  editEvent: 'Edytuj',
};
